import useSWR from 'swr'
import type { SWRConfiguration } from 'swr'

import { useGTMFetchErrorHandling } from './useGTMFetchErrorHandling'
import { ContainersData, GTM_API_LINK, containersSchema, gtmFetcher, gtmSWRErrorHandler } from 'lib/gtm'

export function useGTMContainers(accountId: string | null, options?: SWRConfiguration) {
	const containersFetcher = (url: string) => gtmFetcher({ url, schema: containersSchema })
	const { data, mutate, error } = useSWR<ContainersData>(
		accountId ? `${GTM_API_LINK}/accounts/${accountId}/containers` : null,
		containersFetcher,
		{
			...options,
			revalidateIfStale: false,
			onErrorRetry(_error, key, config, revalidate, revalidateOpts) {
				gtmSWRErrorHandler(_error, revalidate, revalidateOpts)
			},
		},
	)

	useGTMFetchErrorHandling(error)

	return {
		containers: data ? data.container ?? [] : null,
		mutateContainers: mutate,
	}
}
